export enum DeliveryTypesEnum {
        CDashSection = 2146,
        Vaginal = 2147,
        Unknown = 2148,
}
